include ../../../../common/primary/select/select.mixin.pug

PageVue
  .fp-vertical-spacing
    .fp-vertical-spacing--line
      .fp-horizontal-spacing.-s-sm.-items-center
        .fp-horizontal-spacing--column
          button.fp-icon.fp-glyph-chevron-left.-s16.-pointer(data-test='create-giveaway.back' @click='onGoBack')
        .fp-horizontal-spacing--column
          h2.fp-title {{ t('giveawayForm.createTitle') }}
    .fp-vertical-spacing--line(v-if='!giveawayForm.isLoading()')
      GiveawayFormVue#create-giveaway-form(:form-value='giveawayForm.value()' :is-updating='false' :is-cloning='isCloning' @form-valid='valid => setFormValid(valid.value)' @confirm='createGiveaway')
  template(v-slot:footer)
    .fp-horizontal-spacing
      .fp-horizontal-spacing--column
        FairplayerButtonVue(:text='t(\'goBack\')' icon='chevron-left' secondary data-test='create-giveaway.footer.back' @click='onGoBack')
      .fp-horizontal-spacing--column
        FairplayerButtonVue(:text='t(\'giveawayForm.createGiveaway\')' :loading='creating' icon='plus' type='submit' form='create-giveaway-form' data-test='giveaway.form.submit' :disabled='!formValid')
